/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeAUpLeftIcon24Solid = forwardRef('ArrowShapeAUpLeftIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M5.875 3.249A2.625 2.625 0 0 0 3.25 5.874v12.814c0 1.336 1.616 2.006 2.56 1.06l2.97-2.97 4.254 4.254a2.25 2.25 0 0 0 3.182 0l4.815-4.817a2.25 2.25 0 0 0 0-3.181L16.78 8.78l2.971-2.97c.945-.946.276-2.561-1.06-2.561L5.875 3.249Z" })));
});
